import { render } from "./NoteItem.vue?vue&type=template&id=08ddbd9d&scoped=true"
import script from "./NoteItem.vue?vue&type=script&lang=js"
export * from "./NoteItem.vue?vue&type=script&lang=js"

import "./NoteItem.vue?vue&type=style&index=0&id=08ddbd9d&lang=scss&scoped=true"

import exportComponent from "/home/docker/toodles/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08ddbd9d"]])

export default __exports__